import * as Utils from './Utils';

let initialized = [];

export function initialize() {
    let ranges = document.querySelectorAll('[data-range]');


    ranges.forEach(function(item) {

        let collapse = item.closest('.collapse') as HTMLElement;

        if(collapse && collapse.offsetParent === null) {

            let listener = function() {
                console.log('456');
                initialized.push(new RangeSlider(item as HTMLElement));
                collapse.removeEventListener('shown.bs.collapse', listener);
            };

            collapse.addEventListener('shown.bs.collapse', listener, {passive: false});
        } else {
            console.log('123');
            initialized.push(new RangeSlider(item as HTMLElement));
        }
    });

    let resizeEvent = Utils.debounce(function() {
        console.log('resize');
        initialized.forEach(function (item: RangeSlider): void {
            item.disable();
        });

        initialized = [];
        initialize();
        window.removeEventListener('resize', resizeEvent);
    }, 150);

    window.addEventListener('resize', resizeEvent, {passive: false});
}

class RangeSlider
{
    private minimum: MinimumPoint;
    private maximum: MaximumPoint;

    private activePoint?: PointBase;

    private startEventService: (event: MouseEvent | TouchEvent) => void;
    private finishEventService: (event: MouseEvent | TouchEvent) => void;

    constructor(range: HTMLElement)
    {
        let bar = range.querySelector('[data-range-bar]') as HTMLElement;
        let barWidth = bar.clientWidth;

        let formater = new Intl.NumberFormat('cs-CZ', {
            style: 'currency',
            currency: range.dataset.rangeUnits,
            minimumFractionDigits: 0,
        });

        let calcMin = new Calculator(
            parseInt(range.dataset.rangeMin),
            parseInt(range.dataset.rangeMax),
            formater,
            range.querySelector('[data-range-view="min"]') as HTMLElement,
            range.querySelector('[data-range-input="min"]') as HTMLInputElement
        );

        let calcMax = new Calculator(
            parseInt(range.dataset.rangeMin),
            parseInt(range.dataset.rangeMax),
            formater,
            range.querySelector('[data-range-view="max"]') as HTMLElement,
            range.querySelector('[data-range-input="max"]') as HTMLInputElement
        );

        this.minimum = new MinimumPoint(
            range.querySelector('[data-range-point="min"]') as HTMLElement,
            barWidth,
            calcMin
        )

        this.maximum = new MaximumPoint(
            range.querySelector('[data-range-point="max"]') as HTMLElement,
            barWidth,
            calcMax
        )

        this.maximum.setOtherPoint(this.minimum);
        this.minimum.setOtherPoint(this.maximum);

        this.startEventService = this.startMove.bind(this);
        this.finishEventService = this.finishMove.bind(this);
        this.initListeners();
    }

    private initListeners(): void
    {
        // zahajeni posunu
        document.addEventListener('mousedown', this.startEventService, {passive: false});
        document.addEventListener('touchstart', this.startEventService, {passive: false});
        // ukonceni posunu
        document.addEventListener('mouseup', this.finishEventService, {passive: false});
        document.addEventListener('touchend', this.finishEventService, {passive: false});
    }

    disable(): void
    {
        if(this.startEventService) {
            // zahajeni posunu
            document.removeEventListener('mousedown', this.startEventService);
            document.removeEventListener('touchstart', this.startEventService);
        }

        if(this.finishEventService) {
            // ukonceni posunu
            document.removeEventListener('mouseup', this.finishEventService);
            document.removeEventListener('touchend', this.finishEventService);
        }

        this.activePoint?.disable();
    }

    startMove(event: MouseEvent | TouchEvent) {
        console.log('555');

        let current = event.target as HTMLElement;

        if(this.maximum.is(current)) {
            console.log('startMoveMax');
            event.preventDefault();
            this.activePoint = this.maximum;
            this.activePoint.activate(event);
        } else if(this.minimum.is(current)) {
            console.log('startMoveMin');
            event.preventDefault();
            this.activePoint = this.minimum;
            this.activePoint.activate(event);
        }

    }

    finishMove(event: MouseEvent | TouchEvent) {
        console.log('666');
        if(this.activePoint) {
            event.preventDefault();
            this.activePoint.disable();
            this.activePoint = undefined;
        }
    }
}

abstract class PointBase
{
    private readonly point: HTMLElement;

    private readonly moveEvent: (event: MouseEvent | TouchEvent) => void;

    private startMovePosition?: number;
    private startCssPosition: number;

    private minimum: number;
    private maximum: number;

    private calculator: Calculator;
    private otherPoint?: PointBase;

    protected constructor(point: HTMLElement, calculator: Calculator, minimum: number, maximum: number)
    {
        this.point = point;
        this.minimum = minimum;
        this.maximum = maximum;
        this.startCssPosition = calculator.getPresetPosition(maximum-minimum) + minimum;
        this.calculator = calculator;

        point.style.left = this.startCssPosition + 'px';

        this.calculator.setByPosition(this.maximum - this.minimum, this.startCssPosition - this.minimum);

        let callback = (event: MouseEvent | TouchEvent) => this.move(event);
        this.moveEvent = callback.bind(this);
    }

    is(compare: HTMLElement): boolean
    {
        return this.point === compare || this.point.contains(compare);
    }

    activate(event: MouseEvent | TouchEvent): void
    {
        this.startMovePosition = this.getCursorPosition(event);
        this.startCssPosition = parseInt(this.point.style.left);

        document.addEventListener('mousemove', this.moveEvent, {passive: false});
        document.addEventListener('touchmove', this.moveEvent, {passive: false});
    }

    disable(): void
    {
        document.removeEventListener('mousemove', this.moveEvent);
        document.removeEventListener('touchmove', this.moveEvent);
        this.startMovePosition = undefined;
    }

    move(event: MouseEvent | TouchEvent): void
    {
        console.log('777');
        event.preventDefault();

        if(this.startMovePosition) {
            let delta = this.getCursorPosition(event) - this.startMovePosition;
            this.setPosition(delta);
        }
    }

    getCursorPosition(event: MouseEvent | TouchEvent): number
    {
        let isTouchEvent = window.TouchEvent && event instanceof TouchEvent;
        return parseInt(isTouchEvent ? event.touches[0].clientX : event.clientX);
    }

    setPosition(delta: number): void
    {
        let position = this.startCssPosition + delta;

        if(position > this.maximum) {
            position = this.maximum
        }

        if(position < this.minimum) {
            position = this.minimum;
        }

        position = this.checkPositionCollision(position);
        console.log(position);

        this.point.style.left = position + 'px';

        this.calculator.setByPosition(this.maximum - this.minimum, position - this.minimum);
    }

    setOtherPoint(point: PointBase): void
    {
        this.otherPoint = point;
    }

    getPointWidth(): number
    {
        return this.point.clientWidth;
    }

    getPosition(): number
    {
        return parseInt(this.point.style.left);
    }

    checkPositionCollision(desiredPosition: number): number
    {
        if(this.otherPoint) {
            let width = this.otherPoint.getPointWidth();
            let position = this.otherPoint.getPosition();

            let possiblePosition = desiredPosition;
            let newDesiredPosition = desiredPosition;
            let newPosition = 0;

            if(this.otherPoint instanceof MaximumPoint) {
                console.log('isMini');
                newDesiredPosition = desiredPosition + width;
                possiblePosition = position - width;

                newPosition = (position <= newDesiredPosition ? possiblePosition : desiredPosition);
            }

            if(this.otherPoint instanceof MinimumPoint) {
                console.log('isMaxi');
                newDesiredPosition = desiredPosition - width;
                possiblePosition = position + width;

                newPosition = (position >= newDesiredPosition ? possiblePosition : desiredPosition);
            }



            console.log(width, position, desiredPosition, possiblePosition, newPosition);
            return newPosition;
        }
    }
}

class MinimumPoint extends PointBase
{
    constructor(point: HTMLElement, barWidth: number, calculator: Calculator)
    {
        console.log('Minimum Constructor');

        let pointWidth = point.clientWidth;

        let minimum = 0;
        let maximum = barWidth - (2 * pointWidth);

        super(point, calculator, minimum, maximum);
    }
}


class MaximumPoint extends PointBase
{
    constructor(point: HTMLElement, barWidth: number, calculator: Calculator)
    {
        console.log('Maximum Constructor');

        let pointWidth = point.clientWidth;

        let minimum = pointWidth;
        let maximum = barWidth - pointWidth;

        super(point, calculator, minimum, maximum);
    }
}

class Calculator
{
    private readonly minimum: number;
    private readonly maximum: number;

    private view: HTMLElement;
    private input: HTMLInputElement;
    private formater: Intl.NumberFormat

    constructor(minimum: number, maximum: number, formater: Intl.NumberFormat, view: HTMLElement, input: HTMLInputElement)
    {
        this.minimum = minimum;
        this.maximum = maximum;
        this.view = view;
        this.input = input;
        this.formater = formater;
    }

    setByPosition(rangeSize: number, position: number): void
    {
        let val = Math.round(((this.maximum-this.minimum) / rangeSize) * position);
        val += this.minimum;

        this.view.textContent = this.formater.format(val);
        this.input.setAttribute('value', val + '');

        let eventChange = new CustomEvent('change', {bubbles: true});
        this.input.dispatchEvent(eventChange);
    }

    getPresetPosition(rangeSize: number): number
    {
        let val = parseInt(this.input.getAttribute('value') + '') - this.minimum;
        this.view.textContent = this.formater.format(val);

        if(val === this.minimum) {
            return 0;
        }

        if(val === this.maximum) {
            return rangeSize;
        }

        return Math.ceil(val / ((this.maximum-this.minimum) / rangeSize));
    }
}
